import { SortOrder } from 'further-types/utils';
import { z, ZodRawShape } from 'zod';

const withPaginationParamsOptional = <
  T extends ZodRawShape,
  const U extends string,
>(
  schema: z.ZodObject<T>,
  sortableColumns: readonly [U, ...Array<U>],
) => {
  return schema.extend({
    page: z.number().optional(),
    rowsPerPage: z.number().optional(),
    order: z.nativeEnum(SortOrder),
    orderBy: z.enum(['createdAt', 'updatedAt', ...sortableColumns]),
  });
};

export default withPaginationParamsOptional;
